import React from "react";
import { useDropzone } from "react-dropzone";
import upload from "assets/upload.svg";
import { SBBox, SBTypography } from "modules/Commons";
import { SBTranslate } from "i18n";
import { useStyles } from "../style";

interface TransferenceOrderUploaderHelperSelectorProps {
	onFileAccepted: (file: File) => void;
}

const TransferenceOrderUploaderHelperSelector: React.FC<
	TransferenceOrderUploaderHelperSelectorProps
> = ({ onFileAccepted }) => {
	const { getRootProps, getInputProps } = useDropzone({
		onDrop: (acceptedFiles) => {
			onFileAccepted(acceptedFiles[0]);
		},
		noKeyboard: true,
	});
	const classes = useStyles();

	return (
		<SBBox className={classes.selectorUploader}>
			<SBBox className={classes.selectorUploader2}>
				<div {...getRootProps()}>
					<input {...getInputProps()} />
					<img src={upload} alt="Upload" height="150px" />
					<SBTypography textAlign="center">
						{SBTranslate("dragACSVFileHereOnly")}
					</SBTypography>
				</div>
			</SBBox>
		</SBBox>
	);
};

export default TransferenceOrderUploaderHelperSelector;
